import { useEffect, useState } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";
function AddOt() {
    const [ldata, setLdata] = useState(null);
    // Suggestion list ke liye
const [purchaseSuggestions, setPurchaseSuggestions] = useState([]);

    const [formData, setFormData] = useState({
        medicines: [
            {
                sn: 1,
                store_purchase_item_name: '',
                store_purchase_item_unit: '',
                store_purchase_item_rate: '',
                store_purchase_item_qty: '',
                store_purchase_item_dis: '',
                store_purchase_item_dis_amt: '',
                store_purchase_item_gst: '',
                store_purchase_item_total: '',
                store_purchase_item_gtotal:''
            }
        ],
        store_purchase_type:'return1',
        // store_purchase_id: '',
        store_purchase_no: '',
        store_purchase_date: '',
        store_purchase_mode: '',
        store_invoice_number: '',
        store_invoice_date: '',
        store_purchase_vendor: '',
        store_purchase_total: '',
        store_purchase_gtotal:'',
        store_purchase_return_reason:'',
        store_purchase_dis: '',
        store_purchase_gst: '',
        store_purchase_user: '',
         suppliers: [] ,
        page_no: 0,
        alertMsg: '',
        alertMsgTyp: '',
        search_key: '',
        isAlert: false,
    });

    const handleChange = (e) => {

        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        if ((name + "").localeCompare("search_key") == 0) {
            initData();
        }
    };

    const handleChange1 = (e,index) => {
        if (!e || !e.target) return;
        const { name, value } = e.target;
        // alert(name+"");
        const name1 = name.replace(/[0-9]/g, "");

        // alert(name1+"");
        setFormData(prev => {
            const updatedItems = [...prev.medicines];
            updatedItems[index] = {
              ...updatedItems[index],
              [name1]: value
            };
        
            return {
              ...prev,
              medicines: updatedItems
            };
          });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        // alert(formData.email+"");
        const fd = new FormData();

        // purchase_type
        // fd.append('store_purchase_id', formData.store_purchase_id);
        fd.append('store_purchase_no', formData.store_purchase_no);
        fd.append('store_purchase_type', formData.store_purchase_type);
        fd.append('store_purchase_date', formData.store_purchase_date);
        fd.append('store_purchase_mode', formData.store_purchase_mode);
        fd.append('store_invoice_number', formData.store_invoice_number);
        fd.append('store_invoice_date', formData.store_invoice_date);
        fd.append('store_purchase_vendor', formData.store_purchase_vendor);
        fd.append('store_purchase_total', formData.store_purchase_total);
        fd.append('store_purchase_dis', formData.store_purchase_dis);
        fd.append('store_purchase_gst', formData.store_purchase_gst);
        fd.append('store_purchase_gtotal', formData.store_purchase_gtotal);
        fd.append('store_purchase_return_reason', formData.store_purchase_return_reason);
        
        
        fd.append('store_items', JSON.stringify(formData.medicines) + "");
        fd.append('store_purchase_user', ldata.user_id);

        try {
            const response = await axios.post(AppConst.BASE_URL + AppConst.addStorePurchaseUrl, fd, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            if (response.data.status) {
                setFormData(prev => ({
                    ...prev,
                    isAlert: true,
                    alertMsg: response.data.success,
                    alertMsgTyp: response.data.type,
                }));
                sessionStorage.removeItem("opd_dt")
                window.location.href = "/purchase_returns";
            }
            else {
                setFormData(prev => ({
                    ...prev,
                    isAlert: true,
                    alertMsg: response.data.success,
                    alertMsgTyp: response.data.type,
                }));
            }
        } catch (error) {
            setFormData(prev => ({
                ...prev,
                isAlert: true,
                alertMsg: "Failed",
                alertMsgTyp: "danger",
            }));
        }

    };

    const initData = async () => {
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const parsed = JSON.parse(storedData);
            var fd = new FormData();
            fd.append('page_no', "0");
            fd.append('search_key', formData.search_key + "");
            fd.append('test_user', 1 + "");
            try {
                const response = await axios.post(AppConst.BASE_URL + AppConst.getTestListUrl, fd, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                if (response.data.status) {

                    var records = response.data.records;
                    if (records != null && records != undefined) {
                        setFormData(prev => ({
                            ...prev,
                            tests: records
                        }));
                        if (formData.items.length <= 0) {
                            setFormData(prev => ({
                                ...prev,
                                items: records
                            }));
                        }
                    }
                }
            } catch (error) {

            }

            fd = new FormData();
            fd.append('cat_type', "vital");
            fd.append('page_no', "none");
            fd.append('search_key', "");
            fd.append('par_by', 1 + "");
            try {
                const response = await axios.post(AppConst.BASE_URL + AppConst.getCatListUrl, fd, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                if (response.data.status) {

                    var records = response.data.records;
                    if (records != null && records != undefined) {
                        setFormData(prev => ({
                            ...prev,
                            vitals: records
                        }));
                    }
                }
            } catch (error) {

            }
        }
    };
     const initData2 = async () => {
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const parsed = JSON.parse(storedData);
            const fd = new FormData();
            fd.append('type', "supplier1");
            fd.append('search_key', formData.search_key + "");
            fd.append('page_no', formData.page_no + "");
            fd.append('user_cre_by', 1 + "");
            try {
                const response = await axios.post(AppConst.BASE_URL + AppConst.getUserListUrl, fd, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                console.log("supplier : " + JSON.stringify(response))
                if (response.data.status) {

                    var records = response.data.records;
                    if (records != null && records != undefined) {
                        setFormData(prev => ({
                            ...prev,
                            suppliers: records
                        }));
                    }
                }
            } catch (error) {

            }
        }
    };

    useEffect(() => {
        console.log('Component mounted');
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const parsed = JSON.parse(storedData);
            setLdata(parsed);
            initData();
            initData2();
        }

        if (
            sessionStorage.getItem("opd_dt") != null &&
            sessionStorage.getItem("opd_dt") != undefined &&
            sessionStorage.getItem("opd_dt").length > 0
        ) {
            var tmp = JSON.parse(sessionStorage.getItem("opd_dt") + "");
            if (tmp != null && tmp != undefined) {

                var items = tmp.items;

                setFormData(prev => ({
                    ...prev,
                    medicines:items,
                    // store_purchase_id: tmp.store_purchase_id,
                    store_purchase_no: tmp.store_purchase_no,
                    store_purchase_type: tmp.store_purchase_type,
                    store_purchase_date: tmp.store_purchase_date,
                    store_purchase_mode: tmp.store_purchase_mode,
                    store_invoice_number: tmp.store_invoice_number,
                    store_invoice_date: tmp.store_invoice_date,
                    store_purchase_vendor: tmp.store_purchase_vendor,
                    store_purchase_total: tmp.store_purchase_total,
                    store_purchase_dis: tmp.store_purchase_dis,
                    store_purchase_gst: tmp.store_purchase_gst,
                    store_purchase_gtotal: tmp.store_purchase_gtotal,
                    store_purchase_return_reason: tmp.store_purchase_return_reason,
                    store_purchase_user: tmp.store_purchase_user,
                }));
            }
        }



        return () => {
            console.log('Component unmounted');
        };
    }, []);

    const searchPurchaseNow = async (e) => {
  const value = e.target.value;
  setFormData((prev) => ({
    ...prev,
    store_purchase_no: value,
  }));

  if (value.length < 2) {
    setPurchaseSuggestions([]);
    return;
  }

  const storedData = sessionStorage.getItem("ldata");
  if (!storedData) return;

  const parsed = JSON.parse(storedData);
  const fd = new FormData();
  fd.append('page_no', formData.page_no + "");
            fd.append('search_key', formData.search_key + "");
            fd.append('store_purchase_user', 1 + "");
            fd.append('store_purchase_type', "normal");

  try {
    const response = await axios.post(
      AppConst.BASE_URL + AppConst.getStorePurchaseListUrl,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    console.log("suggestion data : " + JSON.stringify(response))

    if (response.data.status && response.data.records) {
      setPurchaseSuggestions(response.data.records);
    } else {
      setPurchaseSuggestions([]);
    }
  } catch (err) {
    console.error(err);
  }
};

const handleSelectPurchase = (purchase) => {
  setFormData((prev) => ({
    ...prev,
    // store_purchase_id: purchase.store_purchase_id || "",
    store_purchase_no: purchase.store_purchase_no || "",
    store_purchase_date: purchase.store_purchase_date || "",
    store_purchase_mode: purchase.store_purchase_mode || "",
    store_invoice_number: purchase.store_invoice_number || "",
    store_invoice_date: purchase.store_invoice_date || "",
    store_purchase_vendor: purchase.store_purchase_vendor || "",
    store_purchase_total: purchase.store_purchase_total || "",
    store_purchase_gtotal: purchase.store_purchase_gtotal || "",
    store_purchase_dis: purchase.store_purchase_dis || "",
    store_purchase_gst: purchase.store_purchase_gst || "",
    store_purchase_return_reason: purchase.store_purchase_return_reason || "",
    medicines: purchase.items || [],   // items bhi autofill karne ke liye
  }));

  setPurchaseSuggestions([]); 
};

    const getVendorName = (id) => {
  const vendor = formData.suppliers.find((v) => v.user_id === id);
  if (!vendor) return id; // agar name na mile to id hi dikhado
  return vendor.fname + (vendor.lname ? " " + vendor.lname : "");
};

    return (
        <div class="page-content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-xxl-12">
                        <div class="card">
                            <div class="card-body">
                                <h5>Purchase Return</h5>
                                <br />
                                <div class="live-preview">
                                    <form onSubmit={handleSubmit}>
                                        <div class="row">

                                          <div className="col-md-4">
  <div className="mb-3 position-relative">
    <label htmlFor="purchase-no-field" className="form-label">Purchase No.</label>
    <input
      id="purchase-no-field"
      name="store_purchase_no"
      value={formData.store_purchase_no}
      className="form-control"
      placeholder="Enter Purchase No."
      type="text"
      autoComplete="off"
      onChange={searchPurchaseNow}   // ✅ yahan sirf ek hi function
    />

    {/* Suggestion list */}
    {purchaseSuggestions.length > 0 && (
      <ul className="list-group position-absolute w-100" style={{ zIndex: 10 }}>
        {purchaseSuggestions.map((p, idx) => (
          <li
            key={idx}
            className="list-group-item list-group-item-action"
            onClick={() => handleSelectPurchase(p)}
            style={{ cursor: "pointer" }}
          >
            {p.store_purchase_no} - <span className="text-muted">{p.store_purchase_vendor}</span>
          </li>
        ))}
      </ul>
    )}
  </div>
</div>

                                            <div class="col-md-4">
                                                <div >
                                                    <label for="customername-field" class="form-label">Purchase Date</label>
                                                    <input name="store_purchase_date" onChange={handleChange} value={formData.store_purchase_date} class="form-control" placeholder="Enter Purchase Date" readOnly  style={{background: "#eee"}}
                                                        type="date" />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div >
                                                    <label for="customername-field" class="form-label">Payment Mode</label>
                                                    <input class="form-control" data-trigger="" 
                                                    name="store_purchase_mode" onChange={handleChange} value={formData.store_purchase_mode} readOnly  style={{background: "#eee"}}/>
                                                     
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div >
                                                    <label for="customername-field" class="form-label">Invoice Number</label>
                                                    <input name="store_invoice_number" onChange={handleChange} value={formData.store_invoice_number} class="form-control" placeholder="Enter Invoice Number" type="text" readOnly  style={{background: "#eee"}} />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div >
                                                    <label for="customername-field" class="form-label">Return Date</label>
                                                    <input name="store_invoice_date" onChange={handleChange} readOnly  style={{background: "#eee"}} value={formData.store_invoice_date} class="form-control" placeholder="Enter Invoice Date"
                                                        type="date" />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div >
                                                    <label for="customername-field" class="form-label">Select Vendor</label>
                                                    <input class="form-control" data-trigger="" 
                                                    name="store_purchase_vendor" onChange={handleChange} 
                                                    value={getVendorName(formData.store_purchase_vendor)} readOnly  style={{background: "#eee"}}/>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div >
                                                    <label for="customername-field" class="form-label">Return Reason</label>
                                                    <textarea name="store_purchase_return_reason" onChange={handleChange} value={formData.store_purchase_return_reason} class="form-control"
                                                        ></textarea>
                                                </div>
                                            </div>
                                            <div class="col-lg-12">
                                                <br />
                                                <div class="row">
                                                    <div class="col-lg-8">
                                                        <h6>Items</h6>
                                                    </div>
                                                    <div class="col-lg-4" style={{ textAlign: "right" }}>
                                                        {/* <button type="button"
                                                         onClick={(e) => {
                                                            e.preventDefault();
                                                            var tmp = formData.medicines;
                                                            tmp.push({
                                                                sn: (tmp.length + 1),
                                                                store_purchase_item_name: '',
                                                                store_purchase_item_unit: '',
                                                                store_purchase_item_rate: '',
                                                                store_purchase_item_qty: '',
                                                                store_purchase_item_dis: '',
                                                                store_purchase_item_dis_amt: '',
                                                                store_purchase_item_gst: '',
                                                                store_purchase_item_total: '',
                                                            });

                                                            setFormData(prev => ({
                                                                ...prev,
                                                                medicines: tmp
                                                            }));

                                                        }}
                                                        class="btn btn-primary">Add</button> */}
                                                    </div>
                                                </div>
                                                <br />
                                            </div>
                                            <div class="col-md-12">
                                                <div class="card-body pt-0">
                                                    <div>

                                                        <div class="table-responsive table-card mb-1">
                                                            <table class="table table-nowrap align-middle" id="orderTable">
                                                                <thead class="text-muted table-light" >
                                                                    <tr class="text-uppercase">

                                                                        <th data-sort="customer_name">Sr. No.</th>
                                                                        <th data-sort="customer_name">Item Name</th>
                                                                        <th data-sort="customer_name">Unit</th>
                                                                        <th data-sort="customer_name">Rate</th>
                                                                        <th data-sort="customer_name">QTY</th>
                                                                        <th data-sort="customer_name">Gst</th>
                                                                        <th data-sort="customer_name">Total</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody class="list form-check-all">
                                                                {formData.medicines.map((item, index) => (
                                                                    <tr>
                                                                        <td class="customer_name">{index+1}.</td>
                                                                        <td class="customer_name">
                                                                            <input type="text" class="form-control" name={'store_purchase_item_name'+index} 
                                                                                value={item.store_purchase_item_name} 
                                                                                onChange={(e) => handleChange1(e,index)} readOnly style={{background: "#EEE"}} />
                                                                        </td>
                                                                        <td class="customer_name">
                                                                            <input type="text" class="form-control" name={'store_purchase_item_unit'+index} 
                                                                                value={item.store_purchase_item_unit} 
                                                                                onChange={(e) => handleChange1(e,index)} readOnly style={{background: "#EEE"}} />
                                                                        </td>
                                                                        <td class="customer_name">
                                                                            <input type="text" class="form-control" name={'store_purchase_item_rate'+index} 
                                                                                value={item.store_purchase_item_rate} 
                                                                                onChange={(e) => handleChange1(e,index)} readOnly style={{background: "#EEE"}} />
                                                                        </td>
                                                                        <td class="customer_name">
                                                                            <input type="text" class="form-control" name={'store_purchase_item_qty'+index} 
                                                                                value={item.store_purchase_item_qty} 
                                                                                onChange={(e) => handleChange1(e,index)} />
                                                                        </td>
                                                                        <td class="customer_name">
                                                                            <input type="text" class="form-control" name={'store_purchase_item_gst'+index} 
                                                                                value={item.store_purchase_item_gst} 
                                                                                onChange={(e) => handleChange1(e,index)} readOnly style={{background: "#EEE"}} />
                                                                        </td>
                                                                        <td class="customer_name">
                                                                            <input type="text" class="form-control" name={'store_purchase_item_total'+index} 
                                                                                value={item.store_purchase_item_total} 
                                                                                onChange={(e) => handleChange1(e,index)} readOnly style={{background: "#EEE"}} />
                                                                        </td>
                                                                    </tr>
                                                                    ))}
                                                                    <tr>
                                                                        <td class="customer_name" colspan="5"></td>
                                                                        <td class="customer_name"><strong>Total</strong></td>
                                                                        <td class="customer_name"><strong>Gst Amount</strong></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td class="customer_name" colspan="5"></td>
                                                                        <td class="customer_name">
                                                                            <input type="text" class="form-control" 
                                                                                name="store_purchase_gtotal" 
                                                                                value={formData.store_purchase_gtotal} 
                                                                                onChange={handleChange} readOnly style={{background: "#EEE"}} />
                                                                        </td>
                                                                        <td class="customer_name">
                                                                            <input type="text" class="form-control" 
                                                                                name="store_purchase_gst" 
                                                                                value={formData.store_purchase_gst} 
                                                                                onChange={handleChange} readOnly style={{background: "#EEE"}} />
                                                                        </td>
                                                                    </tr>
                                                                </tbody>

                                                            </table>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-12">
                                                <div class="text-end">
                                                    <button type="submit" class="btn btn-primary">Save</button>
                                                </div>
                                            </div>
                                        </div>

                                    </form>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AddOt;
